import React, { useState, useEffect } from 'react';
import { Button, Row, Col, Typography, Table, Modal, message } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import Layout from '../components/layout';
import { updateUserApproval } from '../services/authService'; // Update service name
import api from '../api';

const { Title } = Typography;

const AdminUsersPage = () => {
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalAction, setModalAction] = useState(''); // Approve or Reject

  console.log("users page in there")
  // Table columns definition
  const columns = [
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Approved',
      dataIndex: 'approved',
      key: 'approved',
      render: (approved) => (approved ? <CheckCircleOutlined style={{ color: 'green' }} /> : <CloseCircleOutlined style={{ color: 'red' }} />),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="primary" onClick={() => handleAction('approve', record)}>
            Approve
          </Button>
          <Button type="danger" onClick={() => handleAction('reject', record)}>
            Reject
          </Button>
        </>
      ),
    },
  ];

  // Handle Approve or Reject action
  const handleAction = async (action, user) => {
    try {
      setSelectedUser(user);
      setModalAction(action); // Set action for modal message
      setIsModalVisible(true);
    } catch (error) {
      console.error('Error handling action:', error);
      message.error('Failed to process action');
    }
  };

  // Confirm action (Approve/Reject) in modal
  const handleConfirmAction = async () => {
    try {
      const updatedUser = await updateUserApproval(selectedUser.id, { approved: modalAction === 'approve' }); // Update user approval status
        console.log(updatedUser,'the updated user')
      setUserList((prevList) => prevList.map((user) => (user.id === updatedUser.id ? updatedUser : user)));
      setSelectedUser(null); // Clear selected user after action
      setIsModalVisible(false);
      message.success(`${modalAction.charAt(0).toUpperCase() + modalAction.slice(1)}d user successfully.`); // Capitalize first letter
    } catch (error) {
      console.error('Error confirming action:', error);
      message.error('Failed to confirm action');
    }
  };

  // Fetch all users on component mount
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const users = await api.get('/users'); // Replace with your actual API endpoint
        setUserList(users.data);
      } catch (error) {
        console.error('Error fetching users:', error);
        message.error('Failed to fetch users');
      }
    };
    fetchUsers();
  }, []);

  return (
    <Layout>
      <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
        <Title level={2} style={{ textAlign: 'center' }}>
          Admin Users Page
        </Title>
        <Table columns={columns} dataSource={userList} pagination={false} />

        {/* Modal for confirmation */}
        <Modal
          title={`Confirm ${modalAction} User`} // Dynamic title based on action
          visible={isModalVisible}
          onOk={handleConfirmAction}
          onCancel={() => setIsModalVisible(false)}
          okText={modalAction} // Dynamic button text based on action
          okButtonProps={modalAction === 'reject' ? { danger: true } : {}} // Set danger style for reject button
        >
          Are you sure you want to {modalAction} this user? This action cannot be undone.
        </Modal>
      </div>
    </Layout>
  );
};

export default AdminUsersPage;